<template>
  <section class="hero-section">
    <div class="container">
      <div class="row hero-content">
        <div class="col-12 col-lg-6 order-lg-1 order-2 d-flex align-items-center">
          <div class="hero-text-content">

            <h1 class="hero-title">{{ t('hero.title.part1') }}  <span style="color: #3D9BE9;">{{ t('hero.title.part2') }}</span><br>{{ t('hero.title.part3') }}</h1>

            <p class="hero-subtitle">{{ t('hero.subtitle') }}</p>
            
            <!-- Mobile - Concept interactif -->
            <div class="hero-image-container d-block d-lg-none">
              <div class="hero-image-wrapper">
                <div class="interactive-concept">
                  <!-- Image de base qui change selon le mode -->
                  <div class="hero-base-image">
                    <img :src="currentHeroImage" alt="Communication NFC" class="base-image" />
                  </div>
                  
                  <!-- Overlay interactif -->
                  <div class="interactive-overlay">
                    <!-- Background Split -->
                    <div class="split-background">
                      <div class="split-left" :class="{ 'active': businessMode }"></div>
                      <div class="split-right" :class="{ 'active': !businessMode }"></div>
                    </div>
                    
                    <!-- Business Icons -->
                    <div class="icons-container business-icons" :class="{ 'active': businessMode }">
                      <div 
                        v-for="(item, index) in businessIcons" 
                        :key="'business-' + index"
                        class="floating-icon"
                        :style="{ ...item.position, animationDelay: item.delay }"
                      >
                        <div class="icon-wrapper business" :title="item.text">
                          <img :src="item.url" :alt="item.text" class="business-icon" @error="(e) => e.target.style.display = 'none'" />
                          <span class="fallback-emoji">{{ item.icon }}</span>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Social Icons -->
                    <div class="icons-container social-icons" :class="{ 'active': !businessMode }">
                      <div 
                        v-for="(item, index) in socialIcons" 
                        :key="'social-' + index"
                        class="floating-icon"
                        :style="{ ...item.position, animationDelay: item.delay }"
                      >
                        <div class="icon-wrapper social" :title="item.text">
                          <img :src="item.url" :alt="item.text" class="social-favicon" @error="(e) => e.target.style.display = 'none'" />
                          <span class="fallback-emoji">{{ item.icon }}</span>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Toggle Switch au centre -->
                    <div class="toggle-container">
                      <button class="toggle-switch" @click="toggleMode" :class="{ 'business': businessMode }">
                        <div class="toggle-slider">
                          <div class="toggle-dot"></div>
                        </div>
                        <div class="toggle-labels">
                          <span class="label-left">BUSINESS</span>
                          <span class="label-right">SOCIAL</span>
                        </div>
                      </button>
                    </div>
                    
                    <!-- Mode Description -->
                    <div class="mode-description">
                      <transition name="fade" mode="out-in">
                        <div v-if="businessMode" key="business" class="mode-text">
                          <h4>Mode Business</h4>
                          <p>QR Code • Contacts • Networking</p>
                        </div>
                        <div v-else key="social" class="mode-text social">
                          <h4>Mode Social</h4>
                          <p>TikTok • Instagram • LinkedIn • X</p>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="hero-buttons">
              <router-link to="/inscription" class="btn btn-primary btn-lg">{{ t('hero.button.order') }}</router-link>
              <router-link to="/connexion" class="btn btn-outline-primary btn-lg">{{ t('hero.button.login') }}</router-link>
            </div>
          </div>
        </div>
        
        <!-- Desktop - Concept interactif -->
        <div class="col-12 col-lg-6 order-lg-2 order-1 d-none d-lg-block">
          <div class="hero-image-container">
            <div class="hero-image-wrapper">
              <div class="interactive-concept">
                <!-- Image de base qui change selon le mode -->
                <div class="hero-base-image">
                  <img :src="currentHeroImage" alt="Communication NFC" class="base-image" />
                </div>
                
                <!-- Overlay interactif -->
                <div class="interactive-overlay">
                  <!-- Background Split -->
                  <div class="split-background">
                    <div class="split-left" :class="{ 'active': businessMode }"></div>
                    <div class="split-right" :class="{ 'active': !businessMode }"></div>
                  </div>
                  
                  <!-- Business Icons -->
                  <div class="icons-container business-icons" :class="{ 'active': businessMode }">
                    <div 
                      v-for="(item, index) in businessIcons" 
                      :key="'business-' + index"
                      class="floating-icon"
                      :style="{ ...item.position, animationDelay: item.delay }"
                    >
                      <div class="icon-wrapper business" :title="item.text">
                        <img :src="item.url" :alt="item.text" class="business-icon" @error="(e) => e.target.style.display = 'none'" />
                        <span class="fallback-emoji">{{ item.icon }}</span>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Social Icons -->
                  <div class="icons-container social-icons" :class="{ 'active': !businessMode }">
                    <div 
                      v-for="(item, index) in socialIcons" 
                      :key="'social-' + index"
                      class="floating-icon"
                      :style="{ ...item.position, animationDelay: item.delay }"
                    >
                      <div class="icon-wrapper social" :title="item.text">
                        <img :src="item.url" :alt="item.text" class="social-favicon" @error="(e) => e.target.style.display = 'none'" />
                        <span class="fallback-emoji">{{ item.icon }}</span>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Toggle Switch au centre -->
                  <div class="toggle-container">
                    <button class="toggle-switch" @click="toggleMode" :class="{ 'business': businessMode }">
                      <div class="toggle-slider">
                        <div class="toggle-dot"></div>
                      </div>
                      <div class="toggle-labels">
                        <span class="label-left">BUSINESS</span>
                        <span class="label-right">SOCIAL</span>
                      </div>
                    </button>
                  </div>
                  
                  <!-- Mode Description -->
                  <div class="mode-description">
                    <transition name="fade" mode="out-in">
                      <div v-if="businessMode" key="business" class="mode-text">
                        <h4>Mode Business</h4>
                        <p>QR Code • Contacts • Networking</p>
                      </div>
                      <div v-else key="social" class="mode-text social">
                        <h4>Mode Social</h4>
                        <p>TikTok • Instagram • LinkedIn • X</p>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="floating-element floating-1"></div>
    <div class="floating-element floating-2"></div>
    <div class="floating-element floating-3"></div>
  </section>
</template>

<script>
import { useTranslation } from '@/composables/useTranslation'
import { ref, computed } from 'vue'

export default {
  name: 'HeroSection',
  setup() {
    const { t } = useTranslation()
    
    // État pour le mode Business/Social
    const businessMode = ref(true)
    
    // Image qui change selon le mode
    const currentHeroImage = computed(() => {
      return businessMode.value 
        ? require('@/assets/images/imhero1.webp')
        : require('@/assets/images/imhero.webp')
    })
    
    // Icônes Professionnelles spécifiques
    const businessIcons = [
      { icon: '💼', text: 'Business', position: { top: '20%', left: '10%' }, delay: '0s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/briefcase.svg' },
      { icon: '👤', text: 'Contact', position: { top: '40%', left: '15%' }, delay: '0.5s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/person.svg' },
      { icon: '📈', text: 'Growth', position: { top: '60%', left: '8%' }, delay: '1s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/trendingup.svg' },
      { icon: '📱', text: 'Mobile', position: { top: '30%', left: '25%' }, delay: '1.5s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/mobile.svg' }
    ]
    
    // Icônes Réseaux Sociaux avec vraies icônes
    const socialIcons = [
      { icon: '📷', text: 'Instagram', position: { top: '15%', right: '8%' }, delay: '0s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg' },
      { icon: '💼', text: 'LinkedIn', position: { top: '30%', right: '15%' }, delay: '0.5s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/linkedin.svg' },
      { icon: '🐦', text: 'X (Twitter)', position: { top: '45%', right: '5%' }, delay: '1s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/x.svg' },
      { icon: '🎵', text: 'TikTok', position: { top: '60%', right: '12%' }, delay: '1.5s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/tiktok.svg' },
      { icon: '🎥', text: 'YouTube', position: { top: '75%', right: '8%' }, delay: '2s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/youtube.svg' },
      { icon: '👻', text: 'Snapchat', position: { top: '20%', right: '25%' }, delay: '2.5s', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/snapchat.svg' }
    ]
    
    const toggleMode = () => {
      businessMode.value = !businessMode.value
    }
    
    return { 
      t,
      businessMode,
      currentHeroImage,
      businessIcons,
      socialIcons,
      toggleMode
    }
  }
}
</script>

<style lang="scss" scoped>
// Variables existantes
$primary-color: #4285f4;
$secondary-color: #34a853;
$text-dark: #1a1a1a;
$text-gray: #666;

// Mixins existants
@mixin floating-gradient($color) {
  background: linear-gradient(45deg, rgba($color, 0.05), rgba($color, 0.1));
}

@mixin responsive($breakpoint) {
  @media (max-width: $breakpoint) {
    @content;
  }
}

// Keyframes existantes
@keyframes float {
  0% { 
    transform: translate(0, 0) rotate(0deg) scale(1); 
  }
  33% { 
    transform: translate(10px, -15px) rotate(120deg) scale(1.1); 
  }
  66% { 
    transform: translate(-15px, 10px) rotate(240deg) scale(0.9); 
  }
  100% { 
    transform: translate(0, 0) rotate(360deg) scale(1); 
  }
}

@keyframes imageFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

// Styles existants inchangés
.hero-section {
  padding: 2rem 0 4rem;
  margin-top: -1rem;
  background: {
    color: #ffffff;
    image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill='%23f0f0f0' fill-opacity='0.3'%3E%3Cpath d='M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 4c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4z'/%3E%3C/g%3E%3C/svg%3E");
    size: 40px 40px;
  }
  position: relative;
  overflow: hidden;

  @include responsive(992px) {
    padding: 3rem 0;
  }
}

.floating-element {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(0,0,0,0.03) 0%, rgba(0,0,0,0.01) 100%);
  animation: float 20s infinite linear;
  backdrop-filter: blur(5px);

  @include responsive(992px) {
    opacity: 0.5;
  }

  &.floating-1 { 
    width: 150px; 
    height: 150px; 
    top: 15%; 
    left: 5%; 
    animation-delay: 0s;
    @include floating-gradient($primary-color);
  }

  &.floating-2 { 
    width: 100px; 
    height: 100px; 
    bottom: 20%; 
    right: 10%; 
    animation-delay: -5s;
    @include floating-gradient(rgb(219, 68, 55));
  }

  &.floating-3 { 
    width: 70px; 
    height: 70px; 
    bottom: 15%; 
    left: 30%; 
    animation-delay: -10s;
    @include floating-gradient(rgb(244, 180, 0));
  }
}

.hero-content {
  position: relative;
  z-index: 2;
}

.hero-text-content {
  @include responsive(992px) {
    text-align: center;
  }
}

.hero-title {
  font: {
    size: clamp(2rem, 5vw, 3.5rem);
    weight: 800;
  }
  line-height: 1.2;
  color: $text-dark;
  margin-bottom: 1.5rem;
  text-align: left;

  @include responsive(992px) {
    text-align: center;
  }

  span {
    background: linear-gradient(135deg, $primary-color, $secondary-color);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.hero-subtitle {
  font-size: clamp(0.9rem, 1.7vw, 1.15rem);
  color: $text-gray;
  margin-bottom: 2rem;
  max-width: 600px;
  line-height: 1.6;
  text-align: left;

  @include responsive(992px) {
    text-align: left;
    margin: 0 0 2rem 0;
  }
}

// Button Styles
.hero-buttons {
  display: flex;
  gap: 1rem;
  width: 100%;
  margin-top: 2rem;

  .btn {
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
    white-space: nowrap;
    border-radius: 8px !important;
    font-weight: 500;
    text-decoration: none !important;
    transition: all 0.3s ease;
    
    &.btn-primary {
      background-color: #000000 !important;
      border: 2px solid #000000 !important;
      color: white !important;
      
      &:hover {
        background-color: #333333 !important;
        border-color: #333333 !important;
        color: white !important;
      }
      
      &:focus, &:active {
        background-color: #000000 !important;
        border-color: #000000 !important;
        color: white !important;
        box-shadow: none !important;
      }
    }
    
    &.btn-outline-primary {
      background-color: white !important;
      border: 2px solid #000000 !important;
      color: #000000 !important;
      
      &:hover {
        background-color: #f8f9fa !important;
        border-color: #000000 !important;
        color: #000000 !important;
      }
      
      &:focus, &:active {
        background-color: white !important;
        border-color: #000000 !important;
        color: #000000 !important;
        box-shadow: none !important;
      }
    }
  }

  @include responsive(768px) {
    gap: 0.5rem;
    justify-content: center;

    .btn {
      flex: 0 0 calc(50% - 0.25rem);
      padding: 0.7rem 1rem;
      font-size: 0.9rem;
      text-align: center;
    }
  }

  @include responsive(375px) {
    flex-direction: column;
    gap: 0.5rem;

    .btn {
      width: 100%;
      font-size: 0.85rem;
      padding: 0.7rem 0.5rem;
    }
  }
}

.hero-image {
  &-container {
    position: relative;
    z-index: 2;
    margin: 2rem 0;

    @include responsive(992px) {
      margin: 2rem auto;
      max-width: 100%;
    }
  }

  &-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// NOUVEAUX STYLES pour le concept interactif
.interactive-concept {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.hero-base-image {
  position: absolute;
  inset: 0;
  
  .base-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
  }
}

.interactive-overlay {
  position: absolute;
  inset: 0;
  background: transparent;
  backdrop-filter: none;
}

.split-background {
  position: absolute;
  inset: 0;
  display: flex;
  
  .split-left, .split-right {
    width: 50%;
    transition: all 0.7s ease;
    pointer-events: none;
  }
  
  .split-left {
    background: rgba(248, 249, 250, 0.1);
    &.active { background: rgba(241, 243, 244, 0.2); }
  }
  
  .split-right {
    background: rgba(255, 255, 255, 0.05);
    &.active { background: rgba(240, 253, 244, 0.2); }
  }
}

.icons-container {
  position: absolute;
  inset: 0;
  transition: opacity 0.5s ease;
  
  &:not(.active) {
    opacity: 0.3;
  }
}

.floating-icon {
  position: absolute;
  animation: iconFloat 4s ease-in-out infinite;
  
  .icon-wrapper {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: all 0.3s ease;
    cursor: pointer;
    backdrop-filter: blur(5px);
    position: relative;
    
    .social-favicon {
      width: 24px;
      height: 24px;
      object-fit: contain;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    
    .business-icon {
      width: 24px;
      height: 24px;
      object-fit: contain;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      filter: brightness(0) saturate(100%);
    }
    
    .fallback-emoji {
      font-size: 18px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    // Si l'image ne charge pas, afficher l'emoji
    .social-favicon[style*="display: none"] + .fallback-emoji,
    .business-icon[style*="display: none"] + .fallback-emoji {
      opacity: 1;
    }
    
    &:hover {
      transform: scale(1.15);
      box-shadow: 0 8px 20px rgba(0,0,0,0.25);
      background: rgba(255, 255, 255, 0.95);
    }
    
    &.business {
      border: 2px solid rgba($primary-color, 0.4);
      
      &:hover {
        border-color: $primary-color;
        background: rgba($primary-color, 0.1);
      }
    }
    
    &.social {
      border: 2px solid rgba($secondary-color, 0.4);
      
      &:hover {
        border-color: $secondary-color;
        background: rgba($secondary-color, 0.1);
      }
    }
  }
}

.toggle-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.toggle-switch {
  position: relative;
  width: 80px;
  height: 40px;
  background: rgba(229, 231, 235, 0.9);
  border-radius: 20px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  
  &:hover {
    background: rgba(209, 213, 219, 0.9);
    transform: scale(1.05);
  }
  
  &.business {
    .toggle-slider {
      transform: translateX(4px);
      .toggle-dot { background: $primary-color; }
    }
  }
  
  &:not(.business) {
    .toggle-slider {
      transform: translateX(36px);
      .toggle-dot { background: $secondary-color; }
    }
  }
  
  .toggle-slider {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 32px;
    height: 32px;
    background: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    
    .toggle-dot {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transition: background 0.3s ease;
    }
  }
  
  .toggle-labels {
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    
    .label-left, .label-right {
      font-size: 10px;
      font-weight: 700;
      color: rgba(107, 114, 128, 0.8);
      background: rgba(255, 255, 255, 0.9);
      padding: 2px 6px;
      border-radius: 8px;
      backdrop-filter: blur(5px);
    }
    
    .label-right {
      color: rgba($secondary-color, 0.8);
    }
  }
}

.mode-description {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 12px 20px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  
  .mode-text {
    h4 {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 4px;
      color: $text-dark;
      
      &.social { color: $secondary-color; }
    }
    
    p {
      font-size: 11px;
      color: $text-gray;
      margin: 0;
      
      &.social { color: lighten($secondary-color, 10%); }
    }
  }
}

// Animations
@keyframes iconFloat {
  0%, 100% { 
    transform: translateY(0px) rotate(0deg); 
  }
  50% { 
    transform: translateY(-12px) rotate(5deg); 
  }
}

// Transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>